<template>
    <div class="dropdown-menu" :class="{ show: navItem && navItem.isOpen }" @click="navItem && navItem.close()">
        <slot/>
    </div>
</template>
<script>
export default {
    name: 'AppDropDownMenu',
    inject: {
        navItem: { default: null }
    }
}
</script>
